const formato = valor => '$' + Math.round(valor).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
export const convertirUF = (uf, valorUf, ivaPct, modo) => {
  const neto = Math.round(Number(uf) * Number(valorUf));
  const iva = Math.round(neto * Number(ivaPct) / 100);
  return { neto, conIva: neto + iva, medicion: modo === 'neto' ? neto : neto + iva };
};
export const formatoCLP = formato;
export const fechaUFReciente = (fecha, ahora = new Date()) => {
  const iso = String(fecha || '');
  const dia = iso.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z)?$/.test(iso)) return false;
  const fechaMs = Date.parse(dia + 'T00:00:00Z');
  if (!Number.isFinite(fechaMs) || new Date(fechaMs).toISOString().slice(0, 10) !== dia) return false;
  const hoyMs = Date.UTC(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate());
  const dias = (hoyMs - fechaMs) / 86400000;
  return dias >= 0 && dias <= 3;
};
let ufDiaria;
const actualizar = (nodo, valorUf, fuente, fecha = '') => {
  const { neto, medicion } = convertirUF(nodo.dataset.bsUf, valorUf, nodo.dataset.bsIvaPct, nodo.dataset.bsValorMedicion);
  if (!Number.isFinite(neto) || neto <= 0) return;
  const texto = nodo.querySelector('[data-bs-precio-valor]');
  if (texto?.firstChild) texto.firstChild.nodeValue = formato(neto);
  nodo.dataset.valorClp = String(medicion);
  nodo.dataset.bsUfFuente = fuente;
  nodo.dataset.bsUfFecha = fecha;
  const aproximado = nodo.querySelector('[data-bs-precio-aprox]');
  if (aproximado) aproximado.hidden = fuente === 'mindicador';
};
const cargar = async () => {
  if (!ufDiaria) ufDiaria = fetch('https://mindicador.cl/api/uf', { credentials: 'omit', signal: AbortSignal.timeout(3000) })
    .then(respuesta => respuesta.ok ? respuesta.json() : null)
    .then(datos => {
      const dato = datos?.serie?.[0];
      const valor = Number(dato?.valor);
      return valor > 0 && fechaUFReciente(dato?.fecha) ? { valor, fecha: dato.fecha.slice(0, 10), fuente: 'mindicador' } : null;
    })
    .catch(() => null);
  return ufDiaria;
};
const iniciar = () => {
  const nodos = [...document.querySelectorAll('[data-bs-precio]')];
  nodos.forEach(nodo => actualizar(nodo, Number(nodo.dataset.bsUfRespaldo), 'respaldo'));
  cargar().then(dato => {
    if (dato) nodos.forEach(nodo => actualizar(nodo, dato.valor, dato.fuente, dato.fecha));
  });
};
if (typeof document !== 'undefined') {
  const inicio = () => {
    iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicio, { once: true });
  else inicio();
}
